import classes from './Chart.module.css';
import { LineChart, Line, XAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';

const Chart = ({ title, data, dataKey, grid }) => {
    // Custom formatter for tooltip values with comma separation
    const formatTooltipValue = (value) => {
        if (value === null || value === undefined) return '0';
        return Number(value).toLocaleString('en-IN');
    };

    return (
        <div className={classes.chart}>
            <h3 className={classes["chart-title"]}>{title}</h3>
            <ResponsiveContainer width="100%" aspect={3/1}>
                <LineChart data={data} margin={{ top: 10, right: 20, bottom: 80, left: 45 }}>
                    <XAxis dataKey="name" stroke="#209d5c" interval={0} angle={-35} textAnchor="end" height={60} />
                    <Line type="monotone" dataKey={dataKey} stroke="#209d5c" />
                    <Tooltip 
                        formatter={(value) => formatTooltipValue(value)}
                        labelFormatter={(label) => label}
                    />
                    {grid && <CartesianGrid stroke='#e0dfdf' strokeDasharray='5 5' />}
                    <Legend wrapperStyle={{ paddingTop: '40px' }} />
                </LineChart>
            </ResponsiveContainer>
        </div>
    );
}

export default Chart;